import { SET_SOURCE_SETTINGS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCE_SETTINGS_SETTINGS, {
  moveWorkspaceSlug: '',
  showConfirm: false,
  showSourceDeleteConfirm: false,
  showReplaceWriteKeyConfirm: false,
  showMoveSourceConfirm: false,
  showRefreshSchemaConfirm: false,
  showRemoveCollaboratorConfirm: false,
  loading: false,
  isSavingSourceConnection: false,
  isUpgradePromptActive: false,
  isMovingSource: false,
  isUpdatingSource: false,
  isRefreshingSchema: false,
  isRegeneratingWriteKey: false,
  isSavingSourceSettings: false,
  isFetchingCollaborators: false,
  isInvitingCollaborator: false,
  didLoginToFacebookLeadAds: false,
  didLoginToFacebookLeadAdsFail: false,
  accounts: [],
  collaborators: [],
  isSourceSlugValidated: false,
  sourceSlugValidationError: '',
  newSourceSlug: ''
})
